import { DropDown, ToggleSwitch } from "../../commons";
import "react-datepicker/dist/react-datepicker.css";
import Select, { OptionProps, components } from "react-select";
import { STOCK_LIMIT_REPORT_QUANTITY_OPTIONS } from "../../../constant/tableHeadersConstants/reportsConstant/stockLimitReportConst/stockLimitReportConst";
import { AllGroupStockListType } from "../../../redux/clientSettings/clientSettingTypes";
import { Label } from "reactstrap";
import ReactDatePicker from "react-datepicker";
import moment from "moment";
import { CalenderIcon } from "../../Icon";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { NewDownloadIcon } from "../../../assets/images";
import { StockLimitReportDataType } from "../../../redux/reports/reportsType";
import './stockLimitQuantityChart.scss'
type DropDownItemType = {
  value: number | undefined|string;
  label: string | undefined;
};
type AppProps = {
  date: string;
  handleDateChange: (date: any) => void;
  toggle: boolean;
  setToggle: (data: boolean) => void;
  groupStockList: [] | AllGroupStockListType[];
  stockGroupName: DropDownItemType;
  getStockStatement: () => void;
  setQuantitySelected: any;
  quantitySelected: any;
  stocklimitData:[] | StockLimitReportDataType[];
  handlePrepareDownload:()=>void;
  setStockGroupName:React.Dispatch<React.SetStateAction<DropDownItemType>>;
  isDownloadStockLimitReportPresent:boolean;
  handleChangeStatus:()=>void;
  showGraph:boolean;
};

const StockLimitsHeader = ({
  date,
  handleDateChange,
  toggle,
  setToggle,
  groupStockList,
  stockGroupName,
  getStockStatement,
  setQuantitySelected,
  quantitySelected,
  stocklimitData,
  handlePrepareDownload,
  setStockGroupName,
  isDownloadStockLimitReportPresent,
  handleChangeStatus,
  showGraph
}: AppProps) => {

  let finalOptions: any = groupStockList?.map((e: any) => {
    return {
      value: e?.stock_group_id,
      label: e?.stock_group_name,
      count: e?.count,
    };
  });

  const handleGroupNameData = (mode: any) => {
    setStockGroupName({
      value: mode?.value,
      label: mode?.label,
    });
  };


  const Option = (props: OptionProps<any, false>) => {
      return (
        <components.Option {...props}>
          <ul className={`ledger-list`}>
            <li
              style={{
                paddingLeft: `${
                  props?.data?.count !== undefined ? props?.data?.count * 10 : "0"
                }px`,
              }}
            >
              <span
                className={
                  props?.data?.count === undefined
                    ? ""
                    : "stock-nested-list no-show"
                }
              >
                {props?.children}
              </span>
            </li>
          </ul>
        </components.Option>
      );
    };

  return (
    <div className="d-flex justify-content-start align-items-center mb-4">
    
        <div className="col-md-2 pr-0">
          <div className="form-group">
            <div className="date-picker-wraper mr-0">
              <Label className="m-0 p-0 w-100">
                Date <span className="color-red">*</span>
                <ReactDatePicker
                  dateFormat="dd-MM-yyyy"
                  selected={
                    date
                      ? new Date(
                          moment(`${date}T00:00:00`, "YYYY-MM-DD").format(
                            "YYYY-MM-DD[T]HH:mm:ss"
                          )
                        )
                      : null
                  }
                  onChange={(e: any) => {
                    handleDateChange?.(moment(e).format("YYYY-MM-DD"));
                  }}
                  fixedHeight
                  showMonthDropdown
                  showYearDropdown
                  placeholderText="Select Date"
                  className="form-control"
                />
                <span
                  className="calender-icon"
                  style={{ right: "18px", top: "26px", cursor: "pointer" }}
                >
                  <CalenderIcon />
                </span>
              </Label>
            </div>
          </div>
        </div>
       
      <div className="col-md-3 form-group">
        <label>Stock Group <span className="color-red">*</span></label>
        <div>
          <DropDown
            options={finalOptions}
            value={stockGroupName}
            handleChange={handleGroupNameData}
            components={{ Option }}
            
          />
        </div>
      </div>

      <div className=" col-md-2 mb-3 pl-0">
        <label>Quantity</label>
        <Select
          options={STOCK_LIMIT_REPORT_QUANTITY_OPTIONS}
          onChange={(e) => setQuantitySelected(e)}
          isSearchable={true}
          value={
            quantitySelected?.value && quantitySelected?.value !== ""
              ? quantitySelected
              : "Select..."
          }
        />
      </div>
      <div className="mt-1">
        <button
          className="btn btn-primary"
          onClick={getStockStatement}
          disabled={!date?.length || !stockGroupName?.value}
        >
          Get Report
        </button>
      </div>

      {isDownloadStockLimitReportPresent && (
      <div className="ml-3 pr-2">
              <OverlayTrigger
                placement="bottom"
                delay={{ show: 250, hide: 250 }}
                overlay={
                  <Tooltip id="button-view-download-invoice">
                    Download Reports
                  </Tooltip>
                }
              >
                <button
                  className="btn form-control mt-1"
                  style={{ border: "1px solid #bfcbe1" }}
                  onClick={() => handlePrepareDownload()}
                  disabled={!stocklimitData?.length}
                >
                  <img src={NewDownloadIcon} alt="download icon" />
                </button>
              </OverlayTrigger>
            </div>
)}

<label className="switchs ml-1">
                <input
                  type="checkbox"
                  checked={showGraph}
                  onChange={() => handleChangeStatus()}
                />
                <span className="sliders rounds"></span>
              </label>
              <span style={{ fontSize:'16px'}} className="ml-2">Show stock graph</span>


    </div>
  );
};

export default StockLimitsHeader;
